import { axiosInstance } from '@/plugins/axios';

// 优惠相关配置
// getAddProPres: {actionName: 'candao.preferential.getAddProPres'},   // 获取选择餐品加购优惠
// getCanPreList: {actionName: 'candao.preferential.canPreList'},   // 获取可用优惠
// getSelectableCoupons: { actionName: 'candao.coupon.getSelectableCoupons'},  // 获取用户可选择的优惠券列表
// isCanUseGiftCardByCode: {actionName: 'candao.coupon.isCanUseGiftCardByCode'},  // 根据赠送卡号判断赠送卡是否可用
const aciton = {
  coupon: {
    convert: 'candao.coupon.convertCoupon', // 优惠券列表
    list: 'candao.coupon.getValidateCoupons', // 获取有效优惠券列表
    orderCoupon: 'candao.preferential.getRetCouponPre', // 获取订单的下单返券优惠
    userCoupon: 'candao.coupon.getSelectableCoupons', //  获取用户可选择的优惠券列表
    conversion: 'candao.coupon.getSelectableCouponsByExtIds', // 根据第三方id列表获取用户可选择的优惠券列表
  },
  product: {
    add: 'candao.preferential.getAddProPres', // 获取选择餐品加购优惠
    pre: 'candao.preferential.canPreList', // 获取可用优惠
  },
  isCanUseCardCode: 'candao.coupon.isCanUseGiftCardByCode',
};

const coupon = {
  // 兑换优惠券
  convert: ({ actionName = aciton.coupon.convert, ...data }) => axiosInstance({
    method: 'post',
    url: 'Action',
    params: {
      method: 'convertCoupon',
    },
    data: {
      actionName,
      ...data,
    },
  }),
  list: ({ actionName = aciton.coupon.list, ...data }) => axiosInstance({
    method: 'post',
    url: 'Action',
    params: {
      method: 'getValidateCoupons',
    },
    data: {
      actionName,
      ...data,
    },
  }),
  orderCoupon: ({ actionName = aciton.coupon.orderCoupon, ...data }) => axiosInstance({
    method: 'post',
    url: 'Action',
    params: {
      method: 'getRetCouponPre',
    },
    data: {
      actionName,
      ...data,
    },
  }),
  userCoupon: ({ actionName = aciton.coupon.userCoupon, ...data }) => axiosInstance({
    method: 'post',
    url: 'Action',
    params: {
      method: 'getSelectableCoupons',
    },
    data: {
      actionName,
      ...data,
    },
  }),
  conversion: ({ actionName = aciton.coupon.conversion, content, ...data }) => axiosInstance({
    method: 'post',
    url: 'Action',
    params: {
      method: 'getSelectableCouponsByExtIds',
    },
    data: {
      actionName,
      content: Object.assign(content, { posId: 81 }),
      ...data,
    },
  }),
};

const third = {
  list: data => axiosInstance({
    method: 'post',
    url: 'UserXueLi',
    params: {
      method: 'coupons',
      serviceId: 4,
      actionId: 2,
    },
    data,
  }),
};

const product = {
  add: ({ actionName = aciton.product.add, ...data }) => axiosInstance({
    method: 'post',
    url: 'Action',
    params: {
      method: 'getAddProPres',
    },
    data: {
      actionName,
      ...data,
    },
  }),
  pre: ({ actionName = aciton.product.pre, ...data }) => axiosInstance({
    method: 'post',
    url: 'Action',
    params: {
      method: 'canPreList',
    },
    data: {
      actionName,
      ...data,
    },
  }),
};

const isCanUseCardCode = ({ actionName = aciton.isCanUseCardCode, ...data }) => axiosInstance({
  method: 'post',
  url: 'Action',
  params: {
    method: 'isCanUseGiftCardByCode',
  },
  data: {
    actionName,
    ...data,
  },
});

export default {
  coupon,
  product,
  isCanUseCardCode,
  third,
};
